<template>
  <div class="">
    <nav class="navbar navbar-lg navbar-expand-lg navbar-dark bg-primary">
      <div class="container-fluid">
        <router-link class="navbar-brand" to="/user/landing">
          Scales
        </router-link>
        <div class="dropdown">
          <button class="btn btn-outline-white dropdown-toggle mr-2" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{$t('navbar.language')}}
          </button>
          <div class="dropdown-menu">
            <button class="dropdown-item" @click="changeLanguage('en')">
              {{$t('languageChoice.English')}}
            </button>
            <button class="dropdown-item" @click="changeLanguage('zh')">
              {{$t('languageChoice.Chinese')}}
            </button>
            <button class="dropdown-item" @click="changeLanguage('jp')">
              {{$t('languageChoice.Japanese')}}
            </button>
          </div>
        </div>
      </div>
    </nav>
    <main class="main" role="main">
      <div class="py-5 bg-light">
        <div class="container">
          <div class="col-md-12 p-0">
            <div class="mt-4 col-12 col-sm-9 col-md-7 col-lg-6 pl-0 pr-0">
              <ul class="nav nav-tabs wizard pl-0 pr-0">
                <li :class="{active:step===1,completed:step>1}"><a>{{$t('RegisterPage.Terms')}}</a></li>
                <li :class="{active:step===2,completed:step>2}"><a>{{$t('RegisterPage.Input')}}</a></li>
                <li :class="{active:step===3,completed:step>3}"><a>{{$t('RegisterPage.Confrim')}}</a></li>
                <li :class="{active:step>=4}"><a>{{$t('RegisterPage.Complete')}}</a></li>
              </ul>
            </div>
            <div v-if="step===1">
              <div class="card mt-4">
                <div class="card-body pb-2 pr-0">
                  <h4 class="text-center">
                    {{$t('RegisterPage.center')}}
                  </h4>
                  <div class="privacyPolicy-scroll-bar">
                    <div class="pt-4 col-10 offset-1 p-0">
                      <div class="" v-html="$t('privacyPolicy.registerPrivacyPolicy')"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="input-group mt-4">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <input id="confirm" type="checkbox" @click="confirmed=!confirmed" aria-label="Checkbox for following text input" :checked="confirmed">
                  </div>
                </div>
                <label type="text" class="form-control" style="width: auto;flex: none;" aria-label="Text input with checkbox" for="confirm">{{$t('RegisterPage.Confirm')}}</label>
              </div>
            </div>
            <div v-if="step===2||step==3">
              <div class="card mt-4 pt-3 pb-3">
                <div class="card-body">
                  <form label-width="0px" class="demo-ruleForm pt-4 needs-validation" novalidate>
                    <h5 class="card-title pt-3 pl-3 ">{{$t('Registerform.UserInforTitle')}}</h5>
                    <nav class="navbar navbar-light col-12">
                      <div class="col-12 col-md-4">
                        <label for="emailAddress" class="navbar-brand">{{$t('Registerform.Email')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input class="form-control" id="emailAddress" type="email" :value="email" readonly>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="name" class="navbar-brand">{{$t('Registerform.MyName')}}</label>
                      </div>
                      <div class="col-12 col-md-8">
                        <div class="col-12 p-0">
                          <input type="text" class="form-control" id="name" v-model="userInfo.user_name" aria-label="username" aria-describedby="basic-addon2" :readonly="step===3" required>
                          <div class="invalid-feedback">
                            {{$t('Registerform.MyNameTips')}}
                          </div>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="telephone" class="navbar-brand">{{$t('Registerform.MyTelephone')}}</label>
                        <a tabindex="0" class="btn btn-sm border-0" role="button" data-toggle="popover" data-trigger="focus" :title="$t('Registerform.MyTelephone')" :data-content="$t('Registerform.TelephoneTips')"><img src="../../../static/img/info.svg"></a>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="telephone" v-model="userInfo.user_telephone" aria-describedby="basic-addon2" :readonly="step===3" required>
                          <div class="invalid-feedback">
                            {{$t('Registerform.TelephoneTips1')}}
                          </div>
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="language" class="navbar-brand">{{$t('Registerform.language')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <select class="form-control" id="language" v-model="userInfo.language_code" aria-describedby="basic-addon2" :disabled="step===3">
                            <option value="en">{{$t('languageChoice.English')}}</option>
                            <option value="jp">{{$t('languageChoice.Japanese')}}</option>
                            <option value="zh">{{$t('languageChoice.Chinese')}}</option>
                          </select>
                        </div>
                      </div>
                    </nav>
                    <h5 class="card-title pt-3 pl-3 ">{{$t('Registerform.FairFX')}}</h5>
                    <nav class="navbar navbar-light col-12">
                      <div class="col-12 col-md-4">
                        <label for="fairFX" class="navbar-brand">{{$t('Registerform.FairFXNumber')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input class="form-control" id="fairFX" type="text" v-model="userInfo.fairfx_number" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <h5 class="card-title pt-3 pl-3 ">{{$t('Registerform.BankAccount')}}</h5>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="accountHolderName" class="navbar-brand">{{$t('Registerform.accountHolderName')}}</label>
                        <a tabindex="0" class="btn btn-sm border-0" role="button" data-toggle="popover" data-trigger="focus" :title="$t('Registerform.accountHolderName')" :data-content="$t('Registerform.accountHolderNameTips')"><img src="../../../static/img/info.svg"></a>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="accountHolderName" v-model="userInfo.account_name" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="firstName" class="navbar-brand">{{$t('Registerform.firstName')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="firstName" v-model="userInfo.first_name" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="lastName" class="navbar-brand">{{$t('Registerform.lastName')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="lastName" v-model="userInfo.last_name" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="street" class="navbar-brand">{{$t('Registerform.myResidence')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input class="form-control" id="street" v-model="userInfo.account_street" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="city" class="navbar-brand">{{$t('Registerform.mycity')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="city" v-model="userInfo.account_city" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="postcode" class="navbar-brand">{{$t('Registerform.myPostalCode')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="postcode" v-model="userInfo.account_postcode" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="country" class="navbar-brand">{{$t('Registerform.mycountry')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="country" v-model="userInfo.account_country" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="accountNumber" class="navbar-brand">{{$t('Registerform.accountNumber')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="accountNumber" v-model="userInfo.account_number" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="bankName" class="navbar-brand">{{$t('Registerform.bankName')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="bankName" v-model="userInfo.bank_name" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="bankStreet" class="navbar-brand">{{$t('Registerform.bankStreet')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="bankStreet" v-model="userInfo.bank_street" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="bankCountry" class="navbar-brand">{{$t('Registerform.bankCountry')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="bankCountry" v-model="userInfo.bank_country" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="bankSWIFT" class="navbar-brand">{{$t('Registerform.bankSWIFT')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group p-0 col-12">
                          <input type="text" class="form-control" id="bankSWIFT" style="border-bottom-right-radius:0.35rem;border-top-right-radius:0.35rem;" v-model="userInfo.bank_swift" aria-describedby="basic-addon2" :readonly="step===3">
                          <label for="routing" class="navbar-brand ml-3">{{$t('Registerform.routing')}}</label>
                          <input type="text" class="form-control" id="routing" style="border-bottom-left-radius:0.35rem;border-top-left-radius:0.35rem;" v-model="userInfo.bank_routing" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="IBAN" class="navbar-brand">{{$t('Registerform.IBAN')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="input-group col-12 p-0">
                          <input type="text" class="form-control" id="IBAN" v-model="userInfo.account_iban" aria-describedby="basic-addon2" :readonly="step===3">
                        </div>
                      </div>
                    </nav>
                    <nav class="navbar col-12">
                      <div class="col-12 col-md-4">
                        <label for="BACS" class="navbar-brand">{{$t('Registerform.BACS')}}</label>
                      </div>
                      <div class="form-inline col-12 col-md-8">
                        <div class="custom-control custom-checkbox p-0 pl-4">
                          <input id="BACS" class="custom-control-input" type="checkbox" aria-label="Checkbox for following text input" v-model="userInfo.bank_bacs_sepa" :disabled="step===3">
                          <label class="custom-control-label" for="BACS"></label>
                        </div>
                      </div>
                    </nav>
                  </form>
                </div>
              </div>
            </div>
            <div v-if="step===4">
              <div class="p-0 card mt-4 pt-3 pb-3">
                <div class="p-5 text-center">
                  <p>{{$t('Registerform.successful')}}<br>{{$t('Registerform.logininterface')}}</p>
                  <router-link to="/user/login" class="btn btn-lg btn-primary">{{$t('Registerform.Login')}}</router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-end mt-4 col-12 pr-0">
            <div class="col-6">
              <button class="btn btn-outline-secondary mr-3 col-5 col-md-4 col-lg-2" :disabled="step<2" @click="step--" v-if="step<=3&&step>1">{{$t('Registerform.Backbtn')}}</button>
            </div>
            <div class="col-6 text-right pr-0">
              <button class="btn btn-primary" :disabled="!confirmed" @click="next" v-if="step<3">{{$t('RegisterPage.Next')}}</button>
              <button class="btn btn-success" v-if="step===3" @click="regist">{{$t('Registerform.Regist')}}</button>
            </div>
          </div>
        </div>
      </div>
    </main>
    <copyright></copyright>
  </div>
</template>
<style src="../../../static/css/dashboard.css" />

<script type="text/javascript">
import { NmsClient, RestCfg, Env } from '../../scripts/AllExport'
import copyright from './copyright'
import Cookies from 'js-cookie'
let registCheckReqType = 'user-regist-check'
let registInsertReqType = 'user-regist-insert'
export default {
  components: { copyright },
  data: function () {
    return {
      step: 1,
      confirmed: false,
      steps: [
        'step1',
        'step2',
        'step3',
        'step4'
      ],
      email: '',
      userInfo: {

        language_code: 'en',
        bank_bacs_sepa: false
      }
    }
  },
  mounted() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
    $(function () { $("[data-toggle='popover']").popover() })
    $('.popover-dismiss').popover({
      trigger: 'focus'
    })
    this.init()
  },
  methods: {
    init() {
      NmsClient.send(
        RestCfg.POST,
        {
          'reqType': registCheckReqType,
          'id': this.$route.query.id,
          'token': this.$route.query.token
        },
        this.registCheckResult,
        null
      )
    },
    registCheckResult(response) {
      this.email = response.resultInfo.userEmail
    },
    next() {
      if (this.step === 1) this.step++
      else {
        let formValidation = $('.needs-validation')[0]
        if (formValidation.checkValidity()) {
          this.step++
          formValidation.classList.remove('was-validated')
        } else {
          formValidation.classList.add('was-validated')
          if ($('.form-control:invalid').length !== 0) $('.form-control:invalid')[0].focus()
        }
      }
    },
    regist() {
      this.userInfo.bank_bacs_sepa = this.userInfo.bank_bacs_sepa ? 1 : 0
      NmsClient.send(
        RestCfg.POST,
        {
          'reqType': registInsertReqType,
          'id': this.$route.query.id,
          'token': this.$route.query.token,
          'userInfo': this.userInfo
        },
        (response) => {
          this.step++
        },
        null
      )
    },
    changeLanguage(language) {
      let setLanguage = language
      Cookies.set('language', setLanguage, { path: '/', expires: Env.COOKIES_TTL })
      this.$i18n.locale = setLanguage
    }
  },
  watch: {
    step (newStep, oldStep) {
      $(function () { $("[data-toggle='popover']").popover() })
    }
  }

}
</script>
<style scoped>
.navbar {
  font-weight: normal;
}
.navbar-brand button{
  background-color: white;
}
.navbar-brand {
  font-size: 1.25rem;
}
.container{
  min-height:calc(100vh - 278px)
}
.privacyPolicy-scroll-bar{
    overflow: auto;
    height: 420px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/register.vue